__turbopack_context__.v({
  "className": "eb-CGW_className",
  "variable": "eb-CGW_variable",
});
